"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDistance = calculateDistance;
var _geographiclib = _interopRequireDefault(require("geographiclib"));
var _distance = _interopRequireDefault(require("@turf/distance"));
var _config = require("./config");
var _mapUtilsMisc = require("./mapUtilsMisc");
var _transformDistanceWithOptions = _interopRequireDefault(require("./transformDistanceWithOptions"));
var _UnknownDistanceAlgorithmError = _interopRequireDefault(require("../ErrorClasses/UnknownDistanceAlgorithmError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/no-named-as-default */

const {
  FEET,
  KILOMETERS,
  METERS
} = _config.UNITS.DISTANCE;
const geod = _geographiclib.default.Geodesic.WGS84;
function getTurfDistance(currentCoords, otherCoords) {
  // expects [x, y]
  return (0, _distance.default)(currentCoords, otherCoords);
}
const getGeodCoords = (coords1, coords2) => {
  return [...(0, _mapUtilsMisc.formatCoords)(coords1, true), ...(0, _mapUtilsMisc.formatCoords)(coords2, true)];
};
function getGeodDistance(currentCoords, otherCoords) {
  // expects y1, x1, y2, x2, so we always reverse (even if redundent)
  const r = geod.Inverse(...getGeodCoords(currentCoords, otherCoords));
  return r.s12;
}
function getDistanceFromAlgo(currentCoords, otherCoords, algo) {
  switch (algo) {
    case _config.GEO_ALGORITHMS.TURF:
      return getTurfDistance(currentCoords, otherCoords);
    case _config.GEO_ALGORITHMS.GEOD:
      return getGeodDistance(currentCoords, otherCoords);
    default:
      throw new _UnknownDistanceAlgorithmError.default(`Unkown algorithm "${algo}"`);
  }
}
function getUnitOutputedFromAlgorithm(algo) {
  switch (algo) {
    case _config.GEO_ALGORITHMS.TURF:
      return KILOMETERS;
    case _config.GEO_ALGORITHMS.GEOD:
      return METERS;
    default:
      throw new _UnknownDistanceAlgorithmError.default(`Unkown algorithm "${algo}"`);
  }
}

// Note that coords are supposed to be passed in as [lon, lat] - if they need to be reversed, they can be done so with { reversed: true }
// TODO: We should use lat/lon parameters instead of a coords array
function calculateDistance(currentCoords, otherCoords) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    algorithm = _config.GEO_ALGORITHMS.GEOD,
    // TODO: Make sure this changes for scanline

    to = FEET,
    reverse = true,
    ...otherOptions
  } = options;

  // Note that "from" is ignored from "options" as it is implied from the algorithm
  const from = getUnitOutputedFromAlgorithm(algorithm);
  const distance = getDistanceFromAlgo((0, _mapUtilsMisc.formatCoords)(currentCoords, reverse), (0, _mapUtilsMisc.formatCoords)(otherCoords, reverse), algorithm);
  return (0, _transformDistanceWithOptions.default)(distance, {
    to,
    from,
    ...otherOptions
  });
}